define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi",
	"csi/_base/modules",
	"csi/def",
	"csi/def/Field",
	"csi/form/Widget",
	"csi/xml",
	"Apparel/ProductAlternativeFormMixin"
], function(declare,lang,csi,modules,def,Field,Widget,xml,ProductAlternativeFormMixin) {

	return declare([Widget, ProductAlternativeFormMixin], {
		_resolveView: function() {
			// summary: add specification and create-quote fields
			if (this.isCreateForm()) {
				// Specification should only be selected on create, not copy
				this.insertField(lang.mixin(new Field(), {
					m_id: "PASpec",
					m_onChange: "_onChangeSpecification"
				}), 0);
			}

			if (modules.hasModule("Sourcing") && this.isCreateForm()) {
				// we're doing a create, not a copy
				this.insertField(lang.mixin(new Field(), {
					m_label: "CreateQuote",
					m_typeControl: def.FIELD_CHECKBOX
				}));
			}

			this.inherited(arguments);
		},

		_onChangeSpecification: function(/*csi.def.View*/defView, /*Field*/field, /*Any*/value) {
			// summary: update fields based on specification
			var spec = (value == csi.EMPTY_URL) ? null : this.cacheView.getNode(value, true);
			this._updateFieldsFromSpecification(spec);
		}
	});
});